export default function PrinciplesSection() {
  return (
    <section className="w-full bg-background-100 py-28 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-20 lg:px-[100px]">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Left Content */}
          <div className="lg:w-[52%] flex flex-col justify-center">
            <span className="font-label inline-block w-fit px-4 py-2 rounded-full bg-background-200 text-xs font-semibold uppercase tracking-[0.06em] text-foreground-600">
              Our Approach
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-[44px] font-bold text-foreground-950 mt-6 leading-[1.15]">
              Engineering
              <br />
              with purpose and
              <br />
              precision
            </h2>
            <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed mt-8 max-w-[480px]">
              We emphasize continuous innovation, improvement of development workflows, and adoption
              of up-to-date engineering standards to deliver reliable and future-ready IT solutions.
            </p>
          </div>

          {/* Right Card */}
          <div className="lg:w-[48%]">
            <div className="bg-accent-500 rounded-[28px] p-10 md:p-12 min-h-[380px] flex flex-col justify-between">
              <div>
                <p className="font-label text-xs font-medium uppercase tracking-[0.06em] text-background-50/50">
                  Engineering Philosophy
                </p>
                <blockquote className="font-heading text-xl md:text-2xl lg:text-[26px] text-background-50 leading-relaxed mt-6">
                  The team follows modern software engineering practices with a strong focus on
                  usability, stability, and long-term technical quality. Every system is built to
                  be scalable, maintainable, and prepared for the future.
                </blockquote>
              </div>
              <div className="flex items-center gap-4 mt-8 pt-8 border-t border-background-50/10">
                <div className="w-10 h-10 rounded-full border-2 border-background-50/30 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-background-50 text-base"></i>
                </div>
                <div>
                  <p className="font-body text-sm font-semibold text-background-50">
                    Clean Architecture
                  </p>
                  <p className="font-body text-xs text-background-50/50 mt-0.5">
                    User-centered design with rigorous standards
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}